import { ProductDetail } from '@absg/api-formulary';
import { Activity, ReturnWasteLot } from '@absg/api-inventory';
import { Physician } from '@absg/nim-client-shared';

export class PrintingDataModel {
  constructor(public activities: Activity[], public productDetails: ProductDetail[], public physicians: Physician[], public lots: ReturnWasteLot[]) { }
}
